import { render, staticRenderFns } from "./TelemetryOtsParts.vue?vue&type=template&id=36a25495&scoped=true"
import script from "./TelemetryOtsParts.vue?vue&type=script&lang=ts"
export * from "./TelemetryOtsParts.vue?vue&type=script&lang=ts"
import style0 from "./TelemetryOtsParts.vue?vue&type=style&index=0&id=36a25495&prod&lang=scss&scoped=true"
import style1 from "./TelemetryOtsParts.vue?vue&type=style&index=1&id=36a25495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a25495",
  null
  
)

export default component.exports